module.exports = __webpack_public_path__ + "img/社長修3_P01_縮小檔案-1.f7d22663.jpg";